/* Home V3 (round 2 item 11, sp2-home). Deferred. The hero's inline script already painted the saved-bike plate and filled
   the families before first paint (window.SP3H); this file wires the controls.
   - Finder: make chips, family, year (newest first), engine only on a changeover year. Submit saves through
     SP.Garage.add and goes to SP.Garage.shopUrl, the same path as the old inline finder.
   - Re-paints the plate on every garage change (drawer save, switch, remove).
   - Switch chips set the active bike. The FAQ fit step focuses the finder or links the saved bike's system.
   - Events through Shopify.analytics.publish (sp3h_finder_submit, sp3h_known_click, sp3h_switch, sp3h_faq_next).
   Every selector is scoped to the home V3 sections (.sp3h ...), never a bare attribute. */
(function () {
  'use strict';
  var H = window.SP3H;
  if (!H || !H.plate) return;
  var plate = H.plate;
  var V = window.SP_GARAGE_VOCAB || { makes: [] };
  var form = plate.querySelector('form[data-sp3h-finder]');
  var fam = plate.querySelector('select[data-sp3h-family]');
  var yr = plate.querySelector('select[data-sp3h-year]');
  var engWrap = plate.querySelector('.sp3h-field[data-sp3h-engine-wrap]');
  var eng = plate.querySelector('select[data-sp3h-engine]');
  var engLabel = eng ? plate.querySelector('label[for="' + eng.id + '"]') : null;
  var err = plate.querySelector('p[data-sp3h-err]');
  var live = plate.querySelector('[data-sp3h-live]');

  function pub(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {} }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function make() { var i = plate.querySelector('fieldset[data-sp3h-makes] input:checked'); return i ? i.value : ''; }
  function family() {
    var m = V.makes.filter(function (x) { return x.name === make(); })[0];
    return m ? m.families.filter(function (f) { return f.name === fam.value; })[0] : null;
  }
  function gensFor(f, y) { return f ? f.generations.filter(function (g) { return y >= g.years[0] && y <= g.years[1]; }) : []; }
  /* kind: '' clears; 'engine' or 'model' says the third step is the missing one; anything else is the general line */
  function setErr(kind) {
    var d = err.dataset;
    err.textContent = !kind ? '' : kind === 'engine' ? (d.msgEngine || d.msg || '') : kind === 'model' ? (d.msgModel || d.msg || '') : (d.msg || '');
  }
  function announce(text) {
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }
  /* Changeover year, finding 3 (hero QA 2026-10-15): ask about the engine only when every matched generation names
     a distinct one (2017 Softail: Twin Cam or Evo vs Milwaukee-Eight). When they share an engine or none is named
     (2021 to 2026 Sportster: Sportster, Sportster S, Nightster, the last two both Revolution Max) ask which model. */
  function askKind(g) {
    var seen = {};
    for (var i = 0; i < g.length; i++) { var e = g[i].engine; if (!e || seen[e]) return 'model'; seen[e] = 1; }
    return 'engine';
  }

  function fillYears() {
    var f = family();
    engWrap.hidden = true; eng.innerHTML = '<option value="">Which engine?</option>';
    if (!f) { yr.innerHTML = '<option value="">Year</option>'; yr.disabled = true; return; }
    var a = 9999, z = 0, out = [];
    f.generations.forEach(function (g) { a = Math.min(a, g.years[0]); z = Math.max(z, g.years[1]); });
    for (var y = z; y >= a; y--) out.push('<option value="' + y + '">' + y + '</option>');
    yr.innerHTML = '<option value="">Year</option>' + out.join('');
    yr.disabled = false;
  }
  /* say: a rider's year change announces the step in the polite live region (finding 2); the rebuilds from fillYears
     and repaint do not. Focus stays on the year select on purpose (Stealth QA 2026-10-15): the engine select is next in
     Tab order, and moving focus here pulled keyboard users off the year list mid-arrowing on browsers that change a
     closed select per arrow press (Windows Chrome, Firefox). The submit error still focuses the engine select. */
  function fillEngine(say) {
    var g = gensFor(family(), parseInt(yr.value, 10));
    if (g.length > 1) {
      var kind = askKind(g);
      engWrap.setAttribute('data-sp3h-ask', kind);
      eng.innerHTML = '<option value="">' + esc(yr.value) + ': which ' + kind + '?</option>' + g.map(function (x) { return '<option value="' + esc(x.id) + '">' + esc(kind === 'engine' ? x.engine : x.label) + '</option>'; }).join('');
      if (engLabel) engLabel.textContent = kind === 'engine' ? 'Engine' : 'Model';
      engWrap.hidden = false;
      if (say) announce(yr.value + ' was a changeover year. Pick which ' + kind + '.');
    } else { engWrap.hidden = true; engWrap.removeAttribute('data-sp3h-ask'); if (live) live.textContent = ''; }
  }

  plate.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('fieldset[data-sp3h-makes] input')) { H.fill(); fillYears(); setErr(''); }
    else if (t === fam) { fillYears(); setErr(''); }
    else if (t === yr) { fillEngine(true); setErr(''); }
    else if (t === eng) { setErr(''); }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var f = family(), y = parseInt(yr.value, 10), g = gensFor(f, y);
    var gen = g.length > 1 ? g.filter(function (x) { return x.id === eng.value; })[0] : g[0];
    if (!f || !y || !gen) {
      var first = !f ? fam : !y ? yr : eng;
      setErr(first === eng ? (engWrap.getAttribute('data-sp3h-ask') || 'engine') : 'all');
      if (first) first.focus();
      return;
    }
    pub('sp3h_finder_submit', { make: make(), family: f.name, year: y, gen: gen.id });
    if (window.SP && SP.Garage && SP.Garage.add) {
      var b = SP.Garage.add({ genId: gen.id, year: y });
      if (b) { location.href = SP.Garage.shopUrl(b); return; }
    }
    location.href = H.url(gen);
  });

  /* Saved-bike plate: switch chips, the main button, re-paint on change */
  plate.addEventListener('click', function (e) {
    var sw = e.target.closest('button[data-sp3h-switch-id]');
    if (sw && window.SP && SP.Garage) {
      SP.Garage.setActive(sw.getAttribute('data-sp3h-switch-id'));
      pub('sp3h_switch', { bikes: SP.Garage.list().length });
      var go = plate.querySelector('a[data-sp3h-go]');
      if (go) go.focus();
      return;
    }
    var go2 = e.target.closest('a[data-sp3h-go]');
    if (go2) pub('sp3h_known_click', { gen: go2.getAttribute('data-gen') || '', bikes: (window.SP && SP.Garage) ? SP.Garage.list().length : 1 });
  });
  function repaint() {
    var wasKnown = plate.getAttribute('data-sp3h-state') === 'known';
    H.paint();
    if (wasKnown && plate.getAttribute('data-sp3h-state') !== 'known') { H.fill(); fillYears(); }
    paintFaq();
  }
  if (window.SP && SP.Garage && SP.Garage.onChange) SP.Garage.onChange(repaint);
  else document.addEventListener('DOMContentLoaded', function () { if (window.SP && SP.Garage && SP.Garage.onChange) SP.Garage.onChange(repaint); });

  /* FAQ: the fit step focuses the finder, or becomes the saved bike's system link */
  function paintFaq() {
    var go = plate.querySelector('a[data-sp3h-go]');
    var known = plate.getAttribute('data-sp3h-state') === 'known';
    document.querySelectorAll('.sp3h-faqsec a[data-sp3h-fit-next]').forEach(function (a) {
      var t = a.querySelector('span');
      if (known && go) { a.href = go.href; if (t) t.textContent = go.textContent; a.setAttribute('data-known', ''); }
      else { a.href = '#bike-finder'; if (t) t.textContent = a.dataset.defaultText; a.removeAttribute('data-known'); }
    });
  }
  paintFaq();
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.sp3h-faqsec a[data-sp3h-fit-next], .sp3h-faqsec a[data-sp3h-faq-next]');
    if (!a) return;
    pub('sp3h_faq_next', { q: a.getAttribute('data-sp3h-faq-next') || 'fit', known: a.hasAttribute('data-known') });
    if (a.hasAttribute('data-sp3h-fit-next') && !a.hasAttribute('data-known')) {
      e.preventDefault();
      plate.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { fam.focus({ preventScroll: true }); }, 350);
    }
  });
})();
